import React from 'react';

import config from 'config';
import { FaExclamationCircle } from 'react-icons/fa';
import styled from 'styled-components';

import { useProductDetailCTAContext } from './ProductDetailCTAContext';

const ErrorIcon = styled(FaExclamationCircle)`
  color: ${({ theme }) => theme.colors.errorMessage};
  font-size: 16px;
  font-weight: 500;
  vertical-align: text-bottom;
  margin-right: 4px;
`;

const ErrorMessageWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

const ErrorMessage = styled.span`
  color: ${({ theme }) => theme.colors.errorMessage};
  font-size: 14px;
  font-weight: 600;
`;

function CTAErrorMessage() {
  const showIcon = config.get('public.brand.showPDPAddToCartErrorIcon');
  const { errorMessage, showErrors } = useProductDetailCTAContext();

  if (!errorMessage || !showErrors) {
    return null;
  }

  return (
    <ErrorMessageWrapper>
      {showIcon && <ErrorIcon />}
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorMessageWrapper>
  );
}

export default CTAErrorMessage;
